import { PATHS } from '../const/paths.constants';
import { ICreateAccount, ILogin } from '../interfaces/auth.interface';
import { API as API_SERVICE } from './config-service.api';

export const validateEmail = (email: string) => API_SERVICE.post(`${PATHS.DRIVERS}/validate-email`, { email });

export const login = ({ email, password }: ILogin) => API_SERVICE.post(`${PATHS.AUTH}/login`, {
    email,
    password,
    role: 'deliveryPartner',
});

export const signup = (data: ICreateAccount) => API_SERVICE.post('/auth/register', data);

export const deliveryMarketingData = (payload: any) => API_SERVICE.post('/auth/marketing-data', payload);

export const loginWithToken = () => API_SERVICE.post(`${PATHS.AUTH}/verify-token`);

export const forgotPassword = (payload: any) => API_SERVICE.post('/auth/forgot-password', payload);

export const confirmPassword = (payload: any) => API_SERVICE.put('/auth/reset-password', payload);

export const verify2FA = (
    data: { tempToken: string; totpCode?: string; backupCode?: string },
) => (
    API_SERVICE.post(`${PATHS.AUTH}/login/verify-2fa`, data)
);

export const setup2FA = (data?: { tempToken: string }) => (
    API_SERVICE.post(`${PATHS.AUTH}/2fa/setup`, data || {})
);

export const verifySetup2FA = (
    data: { tempToken?: string; totpCode: string; _encrypted: unknown },
) => (
    API_SERVICE.post(`${PATHS.AUTH}/2fa/verify-setup`, data)
);

export const regenerateBackupCodes = () => (
    API_SERVICE.post(`${PATHS.AUTH}/2fa/regenerate-backup-codes`)
);
